import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '读者热评', href: '#comments' },
  { label: '平台优势', href: '#features' },
  { label: '精彩视频', href: '#media' },
  { label: '常见问题', href: '#faq' },
  { label: '专题合集', href: '#index' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-ghost-line text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading font-bold text-xl whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-foreground-50'
            }`}>
              妖精动漫网
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-foreground-50/90 hover:text-foreground-50 hover:bg-white/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors duration-200 ${
              scrolled
                ? 'text-foreground-700 hover:bg-background-100'
                : 'text-foreground-50 hover:bg-white/10'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 rounded-lg text-foreground-700 hover:text-primary-500 hover:bg-primary-50 text-sm font-medium cursor-pointer transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}